
export const FORMAT_DATA = {
    formatId: null,
    facilityCode: null,
    hidId: null,
    toAddEdit: function (controllerId) {
        return {
            hidId: controllerId != null && typeof controllerId != 'undefined' ? controllerId : this.hidId,
            formatId: this.formatId,
            facilityCode: this.facilityCode
        }
    },
    isValid: function () {
        return this.formatId != null && this.facilityCode != null && this.hidId != null;
    },
    isValidFromController: function () {
        return this.formatId != null && this.facilityCode != null;
    },
    isValidFacilityCode: function (val) {
        return val && parseInt(val) > 255;
    }
}
